import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Space,
  Checkbox,
  Switch,
  Divider,
  Alert,
  message,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import DatePicker from "@general/datePicker";
import { degrees } from "@staticData/user/profile";
import UploadFile from "@general/UploadFile";
import { gql, useMutation } from "@apollo/client";
import ConfirmProfile from "@general/confirmProfile";
import RejectProfile from "@general/rejectProfile";
const UPDATEUSER = gql`
  mutation updateUser(
    $id: ID!
    $updateUserInput: UpdateUserInput!
    $confirmUserInput: ConfirmInput!
  ) {
    updateUser(updateInput: $updateUserInput, id: $id)
    confirmUser(id: $id, confirmInput: $confirmUserInput)
  }
`;
function UserProfileData({ formData, confirmStatus, id, onDoUpdateUser }) {
  const [error, setError] = useState(null);
  const [editable, setEditable] = useState(false);
  const [freeDayStatus, setFreeDayStatus] = useState("AVAILABLE");
  const [form] = Form.useForm();

  useEffect(() => {
    setFreeDayStatus(formData?.freeDayStatus);
    form.setFieldsValue(formData);
  }, [formData]);

  const [runUpdateUser, updateUser] = useMutation(UPDATEUSER, {
    onCompleted() {
      message.success("پروفایل کاربر بروزرسانی و تایید شد.");
      onDoUpdateUser();
    },
    onError(err) {
      console.log("خطا: " + err.message);
      message.error("مشکلی پیش آمده! پروفایل کاربر بروز رسانی نشد.");
    },
  });
  const { TextArea } = Input;
  const doUpdateUserProfile = (updateUserInput) => {
    const confirmUserInput = {
      confirmMessage: "پروفایل شما تایید شد.",
      confirmStatus: "SUCCESS",
    };
    runUpdateUser({
      variables: {
        id,
        updateUserInput: { ...updateUserInput, freeDayStatus },
        confirmUserInput,
      },
    });
  };
  if (!confirmStatus)
    return (
      <Alert
        message="این کاربر تا کنون اطلاعاتی ارسال نکرده است!"
        type="warning"
        banner
      />
    );
  return (
    <>
      <Space align>
        <p>ویرایش: </p>
        <Switch onChange={() => setEditable(!editable)} />
      </Space>
      <Form
        layout="vertical"
        onFinish={doUpdateUserProfile}
        form={form}
        disabled={!editable}
      >
        <Row gutter={10}>
          <Col xs={24} lg={12}>
            <Row gutter={15}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="name"
                  id="name"
                  label="نام و نام خانوادگی"
                  rules={[
                    {
                      required: true,
                      message: "لطفا نام خود را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input
                    className="form-input"
                    placeholder={"نام و نام خانوادگی"}
                  />
                </Form.Item>

                <Form.Item
                  name="nationalIdCardNo"
                  label="کد ملی"
                  rules={[
                    {
                      required: true,
                      message: "لطفا کد ملی خود خود را وارد کنید!",
                    },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "لطفا کدملی را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input className="form-input" placeholder="کد ملی" />
                </Form.Item>

                <Form.Item
                  name="birthCertificateNo"
                  label="شماره شناسنامه"
                  rules={[
                    {
                      required: true,
                      message: "لطفا شماره شناسنامه خود خود را وارد کنید!",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "لطفا شماره شناسنامه را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input className="form-input" placeholder="شماره شناسنامه" />
                </Form.Item>

                <Form.Item
                  name="gender"
                  label="جنسیت"
                  style={{ marginBottom: "20px" }}
                  rules={[
                    {
                      required: true,
                      message: "لطفا نام خود خود را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Select
                    placeholder="جنسیت"
                    style={{ width: 120 }}
                    allowClear
                    options={[
                      {
                        value: "FEMALE",
                        label: "خانم",
                      },
                      {
                        value: "MALE",
                        label: "آقا",
                      },
                    ]}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  name="fatherName"
                  id="fatherName"
                  label="نام پدر"
                  rules={[
                    {
                      required: true,
                      message: "لطفا نام پدر خود را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input
                    className="form-input"
                    placeholder={"نام پدر"}
                  />
                </Form.Item>
                <Form.Item
                  name="mobile"
                  label="موبایل"
                  rules={[
                    {
                      required: true,
                      message: "لطفا شماره موبایل خود را وارد کنید!",
                    },
                    {
                      pattern: /^09[0-9]{9}$/,
                      message: "فرمت موبایل صحیح نیست!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input
                    className="form-input"
                    placeholder="شماره موبایل"
                    disabled
                  />
                </Form.Item>

                <Form.Item
                  label="تاریخ تولد"
                  name="birthDate"
                  rules={[{ required: true, message: "این فیلد ضروری است" }]}
                >
                  <DatePicker
                    showToday={false}
                    format="YYYY/MM/DD"
                    className="rtl"
                    placeholder="تاریخ تولد"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item
                  label="آدرس محل سکونت"
                  name="address"
                  rules={[{ required: true, message: "این فیلد ضروری است" }]}
                >
                  <Input.TextArea
                    rows={2}
                    placeholder="آدرس محل سکونت"
                    className="profile-address-textarea"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} lg={12}>
            <Row gutter={15}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="degree"
                  label="تحصیلات"
                  style={{ marginBottom: "20px" }}
                  rules={[
                    {
                      required: true,
                      message: "لطفا تحصیلات خود را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Select placeholder="تحصیلات" allowClear options={degrees} />
                </Form.Item>

                <Form.Item
                  name="birthCertificateImg"
                  label="تصویر شناسنامه"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تصویر شناسنامه خود را آپلود کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <UploadFile square />
                </Form.Item>
                <Form.Item
                  name="profileImg"
                  label="تصویر پروفایل"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تصویر پروفایل خود را آپلود کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <UploadFile crop square />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  name="expertise"
                  label="حوزه فعالیت"
                  style={{ marginBottom: "20px" }}
                  rules={[
                    {
                      required: true,
                      message: "لطفا حوزه فعالیت خود را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <TextArea placeholder="حوزه فعالیت" autoSize />
                </Form.Item>
                <Form.Item
                  name="nationalIdCardImg"
                  label="تصویر کارت ملی"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تصویر کارت ملی خود را آپلود کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <UploadFile square />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="profileImg"
                  label="مدارک دیگر"
                  validateStatus={error && "error"}
                >
                  <Form.List name="otherDocs">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Space
                            key={key}
                            style={{
                              display: "flex",
                              marginBottom: 8,
                            }}
                          >
                            <Form.Item
                              {...restField}
                              name={[name, "docName"]}
                              rules={[
                                {
                                  required: true,
                                  message: "لطفا عنوان فایل را وارد کنید!",
                                },
                              ]}
                            >
                              <Input placeholder="عنوان" />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "docImg"]}
                              rules={[
                                {
                                  required: true,
                                  message: "این فیلد ضروری است!",
                                },
                              ]}
                            >
                              <UploadFile square />
                            </Form.Item>
                            {true && (
                              <MinusCircleOutlined
                                onClick={() => remove(name)}
                              />
                            )}
                          </Space>
                        ))}
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            افزودن
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider orientation="right">روز رایگان</Divider>
        <Row style={{ margin: "20px 0 30px 0" }}>
          {freeDayStatus === "AVAILABLE" ? (
            <Space align>
              <Checkbox onChange={() => setFreeDayStatus("NOT_AVAILABLE")}>
                <p style={{ fontSize: "16px", fontWeight: 500 }}>
                  {formData.name} از روز رایگان خود استفاده کرد.
                </p>
              </Checkbox>
            </Space>
          ) : (
            <Alert
              message={`${formData.name} از روز رایگان خود استفاده کرده است.`}
              type="success"
            />
          )}
        </Row>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            loading={updateUser.loading && true}
          >
            {confirmStatus === "SUCCESS" ? "بروزرسانی" : " بروزرسانی و تایید"}
          </Button>
          {confirmStatus === "PENDING" && (
            <>
              <ConfirmProfile
                id={id}
                disabled={editable}
                onUpdateUser={() => onDoUpdateUser()}
              >
                تایید
              </ConfirmProfile>
              <RejectProfile
                id={id}
                disabled={editable}
                onUpdateUser={() => onDoUpdateUser()}
              >
                عدم تایید
              </RejectProfile>
            </>
          )}
        </Space>
      </Form>
    </>
  );
}

export default UserProfileData;
